import React from "react";

interface InitializationErrorProps {
  error: string;
  onRetry: () => void;
}

const InitializationError: React.FC<InitializationErrorProps> = ({ error, onRetry }) => {
  return (
    <div style={{ 
      display: "flex", 
      alignItems: "center", 
      justifyContent: "center", 
      height: "100vh",
      flexDirection: "column",
      gap: "16px",
      padding: "20px"
    }}>
      <div style={{ 
        background: "#fee", 
        padding: "20px", 
        borderRadius: "8px",
        border: "1px solid #fcc",
        textAlign: "center",
        maxWidth: "400px"
      }}>
        <h3 style={{ color: "#c33", margin: "0 0 12px 0" }}>Initialization Failed</h3>
        <p style={{ color: "#666", margin: "0 0 16px 0" }}>{error}</p>
        <button 
          onClick={onRetry}
          style={{
            background: "#007bff",
            color: "white",
            border: "none",
            padding: "8px 16px",
            borderRadius: "4px",
            cursor: "pointer"
          }}
        >
          Retry
        </button>
      </div>
    </div>
  );
};

export default InitializationError;